<template>
  <div class="position-ab">
    <div class="ccui-app-box-iframe-operate-container" v-show="!showView">
      <template v-if="labelShow">
        <breadcrumbSourcing
          :breadcrumb-data="breadcrumbData"
        ></breadcrumbSourcing>
      </template>
      <div class="ccui-app-iframe-container-detail" v-loading="loading">
        <div class="ccui-app-iframe-container-detail-body">
          <el-tabs class="el-tabs__customize" value="1">
            <el-tab-pane
              :label="
                `${
                  purchaseType == 1 ||
                  purchaseType == 4 ||
                  purchaseType == 7 ||
                  purchaseType == 8
                    ? '评审'
                    : '评标'
                }报告`
              "
              name="1"
            >
              <el-form :model="form" ref="form" label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="项目编号：" prop="projectCode">
                      <span>{{ form.projectCode }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="项目名称：" prop="projectName">
                      <span>{{ form.projectName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="编制人：" prop="agentName">
                      <span>{{ form.agentName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <template v-if="editFlag">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="评审总结：" prop="textInfo">
                        <!-- <el-input
                          v-model="form.textInfo"
                          placeholder="请输入评审总结"
                          type="textarea"
                          maxlength="500"
                          show-word-limit
                          :rows="4"
                        ></el-input> -->
                        <el-kindeditor
                          id="subBidEvaluationReportPreparationEditor"
                          width="100%"
                          :content.sync="form.textInfo"
                          :loadStyleMode="false"
                          :autoHeightMode="true"
                          :uploadJson="editorData.uploadJson"
                          :fileManagerJson="editorData.fileManagerJson"
                          :agentId="editorData.agentId"
                          ref="subBidEvaluationReportPreparationEditor"
                          :headers="editorData.headers"
                          :selectedFile="selectedFile"
                          @on-content-change="
                            onContentChange($event, 'textInfo')
                          "
                          v-model="form.textInfo"
                        ></el-kindeditor>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-else>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="评审总结：" prop="textInfo">
                        <span class="text_info" v-html="form.textInfo"></span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
              </el-form>
            </el-tab-pane>
          </el-tabs>
          <el-tabs class="el-tabs__customize" v-model="active">
            <el-tab-pane
              label="推荐表"
              name="1"
              style="position: relative; padding-top: 45px"
            >
              <el-button
                style="right: 0; position: absolute; top: 2px"
                type="single-number"
                v-preventReClick
                v-if="!editFlag"
                @click="showPdf"
                >导出</el-button
              >
              <el-table
                :data="recommendationTableData"
                border
                :span-method="objectSpanMethodRecommendation"
              >
                <el-table-column
                  prop="id"
                  label="序号"
                  width="55"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="packName"
                  label="包件名称"
                  width="250"
                  show-overflow-tooltip
                  v-if="subPackageFlag"
                ></el-table-column>
                <el-table-column
                  prop="supName"
                  label="分包商名称"
                  width="250"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="行业类型"
                  width="120"
                  prop="industryTypeName"
                  :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                  label="企业规模"
                  width="120"
                  prop="companyTypeName"
                  :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                  prop="taxAmount"
                  label="税额"
                  align="right"
                  min-width="180"
                  show-overflow-tooltip
                >
                  <template slot-scope="{ row }">
                    <span>{{ new BigNumber(row.taxAmount).toFormat(2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="noTaxPriceAmount"
                  label="不含税金额"
                  align="right"
                  min-width="180"
                  show-overflow-tooltip
                >
                  <template slot-scope="{ row }">
                    <span>{{
                      new BigNumber(row.noTaxPriceAmount).toFormat(2)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="priceAmount"
                  label="含税金额"
                  align="right"
                  min-width="180"
                  show-overflow-tooltip
                >
                  <template slot-scope="{ row }">
                    <span>{{
                      new BigNumber(row.priceAmount).toFormat(2)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="
                    `${
                      purchaseType == 1 ||
                      purchaseType == 2 ||
                      purchaseType == 4 ||
                      purchaseType == 7 ||
                      purchaseType == 8
                        ? '响应'
                        : '投标'
                    }文件`
                  "
                  min-width="120"
                  show-overflow-tooltip
                >
                  <template slot-scope="{ row }">
                    <!--@click="viewBidFile(row)"-->
                    <el-button
                      size="mini"
                      type="text"
                      @click="handleSupply(row)"
                      >{{
                        `查看${
                          purchaseType == 1 ||
                          purchaseType == 2 ||
                          purchaseType == 4 ||
                          purchaseType == 7 ||
                          purchaseType == 8
                            ? "响应"
                            : "投标"
                        }文件`
                      }}</el-button
                    >
                  </template>
                </el-table-column>
                <template v-if="evaMethod === '102' || evaMethod === '103'">
                  <template v-for="(item, index) in columns">
                    <el-table-column
                      :key="index"
                      :label="item.label"
                      :width="item.width"
                      show-overflow-tooltip
                    >
                      <template slot-scope="{ row }">
                        <span>{{ showScore(row[item.prop]) }}</span>
                      </template>
                    </el-table-column>
                  </template>
                  <el-table-column
                    v-if="isOld == 1"
                    prop="free4"
                    :label="`投标报价得分`"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="{ row }">
                      {{ new BigNumber(row.free4 || 0).toFormat(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="sumScore"
                    label="汇总得分"
                    width="120"
                    show-overflow-tooltip
                  ></el-table-column>
                </template>
                <el-table-column
                  prop="recommendFlag"
                  label="是否推荐"
                  width="120"
                  show-overflow-tooltip
                >
                  <template slot="header">
                    <span class="star">*</span><span>是否推荐</span>
                  </template>
                  <template slot-scope="{ row }">
                    <template v-if="editFlag">
                      <el-select v-model="row.recommendFlag">
                        <el-option label="推荐" value="1">推荐</el-option>
                        <el-option label="不推荐" value="0">不推荐</el-option>
                      </el-select>
                    </template>
                    <template v-else>{{ row.recommendFlagStr }}</template>
                  </template>
                </el-table-column>
                <template v-if="evaMethod === '102' || evaMethod === '103'">
                  <el-table-column
                    prop="reason"
                    label="说明"
                    show-overflow-tooltip
                    width="250"
                  >
                    <template slot-scope="{ row }">
                      <template v-if="editFlag">
                        <el-input
                          maxlength="500"
                          show-word-limit
                          class="input-short word-limit input-width;"
                          v-model="row.reason"
                          type="textarea"
                          placeholder="请输入说明"
                        ></el-input>
                      </template>
                      <template v-else>
                        {{ row.reason }}
                      </template>
                    </template>
                  </el-table-column>
                </template>
                <template v-else>
                  <el-table-column
                    prop="reason"
                    label="说明"
                    show-overflow-tooltip
                    width="250"
                  >
                    <template slot-scope="{ row }">
                      <template v-if="editFlag">
                        <el-input
                          maxlength="500"
                          show-word-limit
                          class="input-short word-limit input-width;"
                          v-model="row.reason"
                          type="textarea"
                          placeholder="请输入说明"
                        ></el-input>
                      </template>
                      <template v-else>
                        {{ row.reason }}
                      </template>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </el-tab-pane>
            <!--<el-tab-pane label="评标报告手签版" name="2">
              <template v-if="editFlag">
                <div class="fr">
                  <el-upload
                    class="upload-demo tow"
                    :action="uploadForm.action"
                    :on-success="uploadSuccess"
                    accept="doc,.docx,.pdf"
                    :on-error="handleErrorReport"
                    :show-file-list="false"
                    :before-upload="beforeUpload"
                    :on-change="uploadChange"
                    :data="formData"
                  >
                    <span style="color: red"
                      >只能上传word文档或pdf文档且文档个数限制为一个</span
                    >
                    <el-button plain type="single-number">上传附件</el-button>
                  </el-upload>
                </div>
              </template>
              <el-table :data="bidEvaluationReportTableData" border>
                <el-table-column type="index" label="序号" width="55" />
                <el-table-column
                  prop="fileName"
                  label="附件名称"
                  show-overflow-tooltip
                  width="180"
                ></el-table-column>
                <el-table-column prop="fileSize" label="附件大小" width="180">
                  <template slot-scope="{ row }">
                    <span>{{ row.fileSize }}k</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="fileSumm"
                  label="附件说明"
                  show-overflow-tooltip
                >
                  <template slot-scope="{ row }">
                    <template v-if="editFlag">
                      <el-input
                        maxlength="500"
                        show-word-limit
                        class="input-short word-limit input-width;"
                        placeholder="请输入附件说明"
                        v-model="row.fileSumm"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span>{{ row.fileSumm }}</span>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="上传时间"
                  width="170"
                ></el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="{ row, $index }">
                    <template v-if="editFlag">
                      <el-button type="text" @click="deleteFile($index, 0)"
                        >删除</el-button
                      >
                    </template>
                    <el-button type="text" @click="download(row)"
                      >下载</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>-->
            <el-tab-pane label="附件列表" name="3">
              <template v-if="editFlag">
                <div class="fr">
                  <el-upload
                    class="upload-demo tow"
                    :on-change="uploadChange"
                    :action="uploadForm.action"
                    :on-success="uploadOtherFileSuccess"
                    :show-file-list="false"
                    :data="formData"
                    multiple
                  >
                    <el-button plain type="single-number">上传附件</el-button>
                  </el-upload>
                </div>
              </template>
              <el-table :data="otherFileTableData" border>
                <el-table-column type="index" label="序号" width="55" />
                <el-table-column
                  prop="fileName"
                  label="附件名称"
                  show-overflow-tooltip
                  width="180"
                ></el-table-column>
                <el-table-column prop="fileSize" label="附件大小" width="180">
                  <template slot-scope="{ row }">
                    <span>{{ row.fileSize }}K</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="fileSumm"
                  label="附件说明"
                  show-overflow-tooltip
                >
                  <template slot-scope="{ row }">
                    <template v-if="editFlag">
                      <el-input
                        maxlength="500"
                        show-word-limit
                        class="input-short word-limit input-width;"
                        placeholder="请输入附件说明"
                        v-model="row.fileSumm"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span>{{ row.fileSumm }}</span>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="上传时间"
                  width="170"
                ></el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="{ row, $index }">
                    <template v-if="editFlag">
                      <el-button type="text" @click="deleteFile($index, 1)"
                        >删除</el-button
                      >
                    </template>
                    <el-button type="text" @click="download(row)"
                      >下载</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <template v-if="!editFlag">
              <el-tab-pane label="专家确认记录" name="4">
                <el-table
                  :data="expertTableData"
                  border
                  :span-method="objectSpanMethodResult"
                >
                  <el-table-column
                    prop="round"
                    label="确认轮次"
                    width="100"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="id"
                    label="序号"
                    width="55"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="expertName"
                    label="专家姓名"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="{ row }">
                      <template v-if="row.signPicture">
                        <el-popover
                          placement="top-start"
                          title=""
                          trigger="hover"
                        >
                          <img
                            :src="row.signPicture"
                            alt=""
                            style="width: 400px; height: 200px"
                          />
                          <img
                            slot="reference"
                            :src="row.signPicture"
                            style="width: 70px; height: 30px"
                          />
                        </el-popover>
                      </template>
                      <template v-else>
                        <span>{{ row.expertName }}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="confirmResultStr"
                    label="确认结果"
                    width="120"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="confirmOpinion"
                    label="确认意见"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="confirmTime"
                    label="确认日期"
                    width="170"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="confirmStatusStr"
                    label="确认状态"
                    width="120"
                    show-overflow-tooltip
                  ></el-table-column>
                </el-table>
              </el-tab-pane>
            </template>
          </el-tabs>
        </div>
      </div>
      <div class="operate">
        <template v-if="editFlag">
          <el-button
            type="text"
            icon="icon-ccui-save"
            v-preventReClick
            @click="dealBidReportSave"
            >保存</el-button
          >
          <el-button
            type="text"
            icon="icon-ccui-agree"
            v-preventReClick
            @click="dealBidReportSubmit()"
            >提交确认</el-button
          >
          <el-button
            type="text"
            icon="icon-ccui-cancel"
            @click="editFlag = false"
            >取消</el-button
          >
        </template>
        <template v-else>
          <el-button type="text" icon="icon-ccui-edit" @click="editFlag = true"
            >编辑</el-button
          >
          <el-button
            type="text"
            icon="icon-ccui-agree"
            v-preventReClick
            @click="dealBidReportSubmit"
            >提交确认</el-button
          >
          <el-button
            type="text"
            v-preventReClick
            icon="icon-ccui-agree"
            @click="dealBidReportEffect"
            >生效</el-button
          >
          <!--<el-button
            type="text"
            icon="icon-ccui-foresee"
            @click="prviewEvaluePrep"
            >预览评标报告</el-button
          >-->
          <el-button type="text" icon="icon-ccui-sharing-o" @click="init"
            >刷新</el-button
          >
        </template>
      </div>
    </div>

    <!-- 导出pdf预览 -->
    <div class="ccui-app-container-detail" v-if="showView">
      <div class="pdfDom" id="pdfDom">
        <div class="pdfDom-title">
          {{ form.projectName }}
        </div>
        <div class="pdfDom-table">
          <el-row class="pdfDom-table-row">
            <el-col class="pdfDom-table-col" :span="3"
              ><div>项目编号</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="9"
              ><div>
                {{ form.projectCode }}
              </div></el-col
            >
            <el-col class="pdfDom-table-col" :span="3"
              ><div>编制人</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="9"
              ><div>{{ form.agentName }}</div></el-col
            >
          </el-row>
          <el-row class="pdfDom-table-row">
            <el-col class="pdfDom-table-col" :span="3"
              ><div>评审总结</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="21"
              ><div v-html="form.textInfo"></div
            ></el-col>
          </el-row>

          <el-row class="pdfDom-table-row">
            <el-col class="pdfDom-table-col" :span="24"
              ><div>推荐表</div></el-col
            >
          </el-row>
          <el-row class="pdfDom-table-row">
            <el-col class="pdfDom-table-col" :span="1"><div>序号</div></el-col>
            <el-col v-if="subPackageFlag" class="pdfDom-table-col" :span="2"
              ><div>包件名称</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="nameSpan"
              ><div>分包商名称</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2"
              ><div>行业类型</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2"
              ><div>企业规模</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2"><div>税额</div></el-col>
            <el-col class="pdfDom-table-col" :span="2"
              ><div>不含税金额</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2"
              ><div>含税金额</div></el-col
            >
            <el-col
              v-if="showLab('techSumScore')"
              class="pdfDom-table-col"
              :span="2"
              ><div>技术得分</div></el-col
            >
            <el-col
              v-if="showLab('techExtraSumScore')"
              class="pdfDom-table-col"
              :span="2"
              ><div>技术加分项得分</div></el-col
            >
            <el-col
              v-if="showLab('busiSumScore')"
              class="pdfDom-table-col"
              :span="2"
              ><div>商务得分</div></el-col
            >
            <el-col
              v-if="showLab('busiExtraSumScore')"
              class="pdfDom-table-col"
              :span="2"
              ><div>商务加分项得分</div></el-col
            >
            <el-col
              v-if="(evaMethod === '102' || evaMethod === '103') && isOld == 1"
              class="pdfDom-table-col"
              :span="3"
              ><div>
                {{ `投标报价得分` }}
              </div></el-col
            >
            <el-col v-if="isShowHuiz" class="pdfDom-table-col" :span="2"
              ><div>汇总得分</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2"
              ><div>是否推荐</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2"><div>说明</div></el-col>
          </el-row>
          <el-row
            class="pdfDom-table-row"
            v-for="(item, index) in recommendationTableData"
            :key="index"
          >
            <el-col class="pdfDom-table-col" :span="1"
              ><div>{{ index + 1 }}</div></el-col
            >
            <el-col v-if="subPackageFlag" class="pdfDom-table-col" :span="2"
              ><div>{{ item.packName }}</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="nameSpan">
              <div>{{ item.supName }}</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2">
              <div>{{ item.industryTypeName }}</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2">
              <div>{{ item.companyTypeName }}</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2"
              ><div>
                {{ new BigNumber(item.taxAmount).toFormat(2) }}
              </div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2"
              ><div>
                {{ new BigNumber(item.noTaxPriceAmount).toFormat(2) }}
              </div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2"
              ><div>
                {{ new BigNumber(item.priceAmount).toFormat(2) }}
              </div></el-col
            >
            <el-col
              v-if="showLab('techSumScore')"
              class="pdfDom-table-col"
              :span="2"
              ><div>{{ item.techSumScore }}</div></el-col
            >
            <el-col
              v-if="showLab('techExtraSumScore')"
              class="pdfDom-table-col"
              :span="2"
              ><div>{{ item.techExtraSumScore }}</div></el-col
            >
            <el-col
              v-if="showLab('busiSumScore')"
              class="pdfDom-table-col"
              :span="2"
              ><div>{{ item.busiSumScore }}</div></el-col
            >
            <el-col
              v-if="showLab('busiExtraSumScore')"
              class="pdfDom-table-col"
              :span="2"
              ><div>{{ item.busiExtraSumScore }}</div></el-col
            >
            <el-col
              v-if="(evaMethod === '102' || evaMethod === '103') && isOld == 1"
              class="pdfDom-table-col"
              :span="3"
              ><div>
                {{ new BigNumber(item.free4 || 0).toFormat(2) }}
              </div></el-col
            >
            <el-col v-if="isShowHuiz" class="pdfDom-table-col" :span="2"
              ><div>{{ item.sumScore }}</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2"
              ><div>{{ item.recommendFlagStr }}</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2"
              ><div>{{ item.reason }}</div></el-col
            >
          </el-row>

          <el-row class="pdfDom-table-row">
            <el-col class="pdfDom-table-col" :span="24"
              ><div>专家确认记录</div></el-col
            >
          </el-row>
          <el-row class="pdfDom-table-row">
            <el-col class="pdfDom-table-col" :span="3"
              ><div>确认轮次</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="1"><div>序号</div></el-col>
            <el-col class="pdfDom-table-col" :span="3"
              ><div>专家姓名</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2"
              ><div>确认结果</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="7"
              ><div>确认意见</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="6"
              ><div>确认日期</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2"
              ><div>确认状态</div></el-col
            >
          </el-row>
          <el-row
            class="pdfDom-table-row"
            v-for="(item, index) in expertTableData"
            :key="index"
          >
            <el-col class="pdfDom-table-col" :span="3"
              ><div>{{ item.round }}</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="1"
              ><div>{{ index + 1 }}</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="3"
              ><div>
                <template v-if="item.signPicture">
                  <el-popover placement="top-start" title="" trigger="hover">
                    <img
                      :src="item.signPicture"
                      alt=""
                      style="width: 400px; height: 200px"
                    />
                    <img
                      slot="reference"
                      :src="item.signPicture"
                      style="width: 70px; height: 30px"
                    />
                  </el-popover>
                </template>
                <template v-else>
                  <span>{{ item.expertName }}</span>
                </template>
              </div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2"
              ><div>{{ item.confirmResultStr }}</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="7"
              ><div>{{ item.confirmOpinion }}</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="6"
              ><div>{{ item.confirmTime }}</div></el-col
            >
            <el-col class="pdfDom-table-col" :span="2"
              ><div>{{ item.confirmStatusStr }}</div></el-col
            >
          </el-row>
        </div>
      </div>
      <!--  按钮  -->
      <el-bottom-guide>
        <ul class="ccui-bottom-button">
          <li>
            <el-button
              type="bottom"
              icon="icon-ccui-return"
              @click="showView = false"
              >关闭
            </el-button>
          </li>
          <div class="ccui-bottom-guide-divider" />
          <li>
            <el-button type="bottom" icon="icon-ccui-reject" @click="getPdf"
              >导出
            </el-button>
          </li>
        </ul>
      </el-bottom-guide>
    </div>

    <el-dialog
      :visible.sync="supplierBidDetailsdialogVisible"
      :title="
        `分包商${
          purchaseType == 1 ||
          purchaseType == 2 ||
          purchaseType == 4 ||
          purchaseType == 7 ||
          purchaseType == 8
            ? '响应'
            : '投标'
        }详细信息`
      "
      width="1200px"
      v-if="supplierBidDetailsdialogVisible"
    >
      <supplierBidDetails
        :supCode="supBidDetailData.supCode"
        :supPackQuoteId="supBidDetailData.supPackQuoteId"
        :packId="supBidDetailData.packId"
      ></supplierBidDetails>
      <div slot="footer"></div>
    </el-dialog>
  </div>
</template>

<script>
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import BigNumber from "bignumber.js";
import Cookies from "js-cookie";
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import {
  scpQryBidReportDetailApi,
  scpQryFileinfoListApi,
  scpDealBidReportSaveApi,
  scpQryBidReportExpertConfirmListApi,
  scpQryBidReportRecommendListApi,
  scpDealBidReportSubmitApi,
  scpDealBidReportEffectApi,
  scpQryBidEvaProcessStatusApi,
  selectSchemeVersionById,
  scpListPurchaseSchemePackageApi
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
import bidEvaProcessStatus from "@/app/subSourcingFlow/mixins/getBidEvaProcessStatus.js";
import supplierBidDetails from "@/app/subSourcingFlow/views/supplierBidDetails.vue";
import { addUrlPerFix } from "@/basa/utils";
import { qryNoticeTemplateMaintainList } from "@/app/subSourcingFlow/api/noticeTemplateMaintainList.js";

export default {
  name: "bidEvaluationReportPreparation",
  components: {
    breadcrumbSourcing,
    supplierBidDetails
  },
  mixins: [bidEvaProcessStatus],
  inject: ["reload"],
  data() {
    return {
      nameSpan: 2,
      showView: false,
      isShowHuiz: true,
      isOld: "",
      BigNumber: BigNumber,
      formData: {
        agentId: this.$router.history.current.query.a
      },

      breadcrumbData: {
        titname: "评标报告编制",
        status: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
          .billStatusName
      },
      editFlag:
        JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus ==
        "0"
          ? true
          : false, // 是否是编辑状态
      // 080701  0  编辑中 080701  1  确认中 080701  2  确认结束 080701  3  已生效
      labelType:
        JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus ===
        "0"
          ? "editorial"
          : JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
              .billStatus === "1"
          ? "confirmation"
          : JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
              .billStatus === "3"
          ? "executed"
          : "confirmed",
      form: {},
      active: "1",
      expertTableData: [], // 专家确认记录
      recommendationTableData: [], // 推荐表数据
      bidEvaluationReportTableData: [], // 评标报告手签版
      otherFileTableData: [], // 其他附件
      uploadForm: {
        action: this.$addUrlPerFix(
          process.env.VUE_APP_BASE_URL +
            "/apis/bid-scp/oss/uploadFileToOssAndSave"
        ),
        headers: {
          Authorization: Cookies.get("access_token") || ""
        }
      },
      bidReportId: "",
      FileInfoBOs: [], // 新上传的附件
      evaMethod: JSON.parse(sessionStorage.getItem("bidEvaPrepareDetailData"))
        .evaMethod, // 评标法 101：最低价评标法  102：综合评标法
      labelShow: true,
      loading: false,
      subPackageFlag: true,
      purchaseType: "",
      columns: [],
      supplierBidDetailsdialogVisible: false,
      supBidDetailData: {
        supQuoteId: 0, // 分包商报价ID
        supPackQuoteId: "",
        supCode: "", // 分包商编号
        packId: "" //包件Id
      },
      editorData: {
        background2: "", // 双向同步的变量
        editorTextCopy: "", // content-change 事件回掉改变的对象
        fileManagerJson: [],
        headers: { Authorization: Cookies.get("access_token") || "" },
        agentId: this.$route.query.a,
        uploadJson:
          addUrlPerFix(process.env.VUE_APP_BASE_URL) +
          "/apis/bid/oss/uploadTextEditorFileToOss"
      },
      templateList: [] //模版集合
    };
  },
  mounted() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    this.getData(true);
  },
  created() {
    this.getSubPackageFlag();
    this.selectSchemeVersionById();
  },
  watch: {
    purchaseType: {
      handler(newVal) {
        if (newVal == 1 || newVal == 4 || newVal == 7 || newVal == 8) {
          this.breadcrumbData.titname = "评审报告编制";
        }
      }
    }
  },
  methods: {
    handleSupply(row) {
      this.supBidDetailData.supCode = row.supCode;
      this.supBidDetailData.supPackQuoteId = row.supPackQuoteId;
      this.supBidDetailData.packId = row.packId;
      this.supplierBidDetailsdialogVisible = true;
    },
    showScore(num) {
      if (num === null || num === "" || num === undefined) {
        return "-";
      } else {
        return num;
      }
    },
    selectSchemeVersionById() {
      selectSchemeVersionById({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // 是否新单子 1是0不是
        this.isOld = res.data.data.version;
      });
    },

    getSpan() {
      // 分包商所占宽度，根据打分项动态显示
      console.log(this.columns, "columns///");
      this.nameSpan = 2 + (4 - this.columns.length) * 2;
      if (this.evaMethod != "102" && this.evaMethod != "103") {
        // 没有汇总得分和投标报价得分
        this.nameSpan += 4;
        this.isShowHuiz = false;
      } else {
        this.isShowHuiz = true;
        if (this.isOld != 1) {
          this.nameSpan += 2;
        }
      }
    },
    getSubPackageFlag() {
      scpListPurchaseSchemePackageApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // 是否分包 1分包0不分包
        // subPackageFlag 是否分包 1分包0不分包
        this.subPackageFlag =
          res.data.data.subPackageFlag == "1" ? true : false;
      });
    },
    init(type) {
      if (type) {
        this.getData();
      } else {
        this.reload();
        this.getData(true);
      }
    },

    getPdf() {
      var title = this.form.projectName;

      html2Canvas(document.querySelector("#pdfDom"), {
        allowTaint: true
      }).then(function(canvas) {
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        let pageHeight = (contentWidth / 592.28) * 841.89;
        let leftHeight = contentHeight;
        let position = 0;
        let imgWidth = 595.28;
        let imgHeight = (592.28 / contentWidth) * contentHeight;
        let pageData = canvas.toDataURL("image/jpeg", 1.0);
        let PDF = new JsPDF("", "pt", "a4");
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        PDF.save(title + ".pdf");
      });
    },

    showPdf() {
      this.getSpan();
      this.showView = true;
    },

    showLab(name) {
      let bol = false;
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].prop == name) {
          bol = true;
          break;
        }
      }
      return bol;
    },

    getData(type) {
      scpQryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep: this.$router.history.current.query.menuKey
      }).then(res => {
        console.log(res, "res.....");
        this.$set(this, "labelShow", false);
        if (type) {
          this.$set(
            this,
            "editFlag",
            res.data.data.billStatus == "0" ? true : false
          );
        } else {
          console.log("1111111111111111");
        }

        this.labelType =
          res.data.data.billStatus === "0"
            ? "editorial"
            : res.data.data.billStatus === "1"
            ? "confirmation"
            : res.data.data.billStatus === "3"
            ? "executed"
            : "confirmed";
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        this.$set(
          this.breadcrumbData,
          "status",
          JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
            .billStatusName
        );
        this.$set(this, "active", "1");
        this.$set(this, "labelShow", true);
      });
      // 查看详情
      scpQryBidReportDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        this.form = res.data.data;
        this.bidReportId = res.data.data.bidReportId;

        // 获取报告模版
        let param = {
          isShowPageLoading: true
        };
        qryNoticeTemplateMaintainList(param).then(res => {
          if (res.data.code === "0") {
            this.templateList = res.data.data;
            if (
              !this.form.textInfo &&
              this.editFlag &&
              this.templateList &&
              this.templateList.length > 0
            ) {
              let instructions = "";
              this.templateList.forEach(item => {
                switch (Number(this.purchaseType)) {
                  case 0:
                    // 公开招标
                    if (item.step == 107) {
                      instructions = item.templateContent;
                    }
                    break;
                  case 3:
                    // 邀请招标
                    if (item.step == 207) {
                      instructions = item.templateContent;
                    }
                    break;
                  case 4:
                    // 谈判-邀请
                    if (item.step == 307) {
                      instructions = item.templateContent;
                    }
                    break;
                  case 1:
                    // 询比-邀请
                    if (item.step == 407) {
                      instructions = item.templateContent;
                    }
                    break;
                  case 7:
                    // 询比-公开
                    if (item.step == 507) {
                      instructions = item.templateContent;
                    }
                    break;
                  case 8:
                    // 询比-公开
                    if (item.step == 607) {
                      instructions = item.templateContent;
                    }
                    break;
                }
              });
              this.form.textInfo = instructions;
            }
          }
        });

        // 其他附件
        scpQryFileinfoListApi({
          parentBillId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          billId: this.bidReportId,
          billType: "0807",
          uploadPhase: "0807"
        }).then(res => {
          this.otherFileTableData = JSON.parse(JSON.stringify(res.data.data));
        });
        // 手签版
        scpQryFileinfoListApi({
          parentBillId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          billId: this.bidReportId,
          billType: "080701",
          uploadPhase: "080701"
        }).then(res => {
          this.bidEvaluationReportTableData = res.data.data;
        });
      });
      // 专家确认列表
      scpQryBidReportExpertConfirmListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        bidReportId: this.bidReportId,
        pageNo: -1,
        pageSize: -1
      }).then(res => {
        if (res.data.code === "0") {
          let list = {};
          res.data.data.rows.map(item => {
            list[item.round] = list[item.round] || [];
            list[item.round].push(item);
          });
          let arr = [];
          Object.keys(list).map(key => {
            arr.push(list[key]);
          });
          arr.sort(function(a, b) {
            return a[0].round - b[0].round;
          });
          let devspan = 0;
          let newData = [];
          arr.forEach((item, index) => {
            if (index > 0) {
              devspan += arr[index - 1].length;
            }
            item.forEach((itemtow, indextow) => {
              let obj = {
                id: indextow + 1,
                reportConfirmId: itemtow.reportConfirmId,
                joinExpertId: itemtow.joinExpertId,
                expertName: itemtow.expertName,
                round: itemtow.round,
                confirmResult: itemtow.confirmResult,
                confirmResultStr: itemtow.confirmResultStr,
                confirmOpinion: "",
                confirmTime: itemtow.confirmTime,
                confirmStatus: itemtow.confirmStatus,
                confirmStatusStr: itemtow.confirmStatusStr,
                rowspan: item.length,
                signPicture: itemtow.signPicture,
                devspan: devspan
              };
              if (itemtow.confirmOpinion == "" && itemtow.confirmResult) {
                if (itemtow.confirmResult == 1) {
                  obj.confirmOpinion = "同意";
                } else {
                  obj.confirmOpinion = "不同意";
                }
              } else {
                obj.confirmOpinion = itemtow.confirmOpinion;
              }
              newData.push(obj);
            });
          });
          this.expertTableData = newData;
        }
      });
      // 推荐表
      scpQryBidReportRecommendListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        if (res.data.code === "0") {
          this.columns = [];
          let data = [];
          let devspan = 0;
          let id = 0;
          res.data.data.forEach((item, index) => {
            if (index > 0) {
              devspan += res.data.data[index - 1].sscBidReportSupBOS.length;
            }
            if (this.subPackageFlag) {
              id++;
            } else {
              id = 0;
            }
            if (item.sscBidReportSupBOS && item.sscBidReportSupBOS.length > 0) {
              item.sscBidReportSupBOS.forEach((itemtow, indextow) => {
                if (!this.subPackageFlag) {
                  id++;
                }
                let obj = {
                  id: id,
                  packName: item.packName,
                  packId: item.packId,
                  scoreSumId: itemtow.scoreSumId,
                  supCode: itemtow.supCode,
                  supName: itemtow.supName,
                  techSumScore: itemtow.techSumScore,
                  busiSumScore: itemtow.busiSumScore,
                  sumScore: itemtow.sumScore,
                  free4: itemtow.free4,
                  priceAmount: itemtow.priceAmount,
                  taxAmount: itemtow.taxAmount,
                  noTaxPriceAmount: itemtow.noTaxPriceAmount,
                  supPackQuoteId: itemtow.supPackQuoteId,
                  supJoinId: itemtow.supJoinId,
                  supQuoteId: itemtow.supQuoteId,
                  recommendFlag: itemtow.recommendFlag,
                  techExtraSumScore: itemtow.techExtraSumScore,
                  busiExtraSumScore: itemtow.busiExtraSumScore,
                  industryTypeName: itemtow.industryTypeName,
                  companyTypeName: itemtow.companyTypeName,
                  recommendFlagStr:
                    itemtow.recommendFlag == "1"
                      ? "推荐"
                      : itemtow.recommendFlag == "0"
                      ? "不推荐"
                      : "-",
                  reason: itemtow.reason,
                  rowspan: item.sscBidReportSupBOS.length,
                  devspan: devspan
                };
                if (
                  obj.techSumScore !== undefined &&
                  obj.techSumScore !== null &&
                  obj.techSumScore !== "" &&
                  !this.columns.some(item => {
                    return item.prop === "techSumScore";
                  })
                ) {
                  this.columns.push({
                    prop: "techSumScore",
                    label: "技术得分",
                    width: 120
                  });
                }
                if (
                  obj.techExtraSumScore !== undefined &&
                  obj.techExtraSumScore !== null &&
                  obj.techExtraSumScore !== "" &&
                  !this.columns.some(item => {
                    return item.prop === "techExtraSumScore";
                  })
                ) {
                  this.columns.push({
                    prop: "techExtraSumScore",
                    label: "技术加分项得分",
                    width: 120
                  });
                }
                if (
                  obj.busiSumScore !== null &&
                  obj.busiSumScore !== undefined &&
                  obj.busiSumScore !== "" &&
                  !this.columns.some(item => {
                    return item.prop === "busiSumScore";
                  })
                ) {
                  this.columns.push({
                    prop: "busiSumScore",
                    label: "商务得分",
                    width: 120
                  });
                }
                if (
                  obj.busiExtraSumScore !== null &&
                  obj.busiExtraSumScore !== undefined &&
                  obj.busiExtraSumScore !== "" &&
                  !this.columns.some(item => {
                    return item.prop === "busiExtraSumScore";
                  })
                ) {
                  this.columns.push({
                    prop: "busiExtraSumScore",
                    label: "商务加分项得分",
                    width: 120
                  });
                }
                data.push(obj);
              });
              console.log(data, "data/////////////");
            }
          });
          console.log(
            this.recommendationTableData,
            "this.recommendationTableData."
          );
          this.recommendationTableData = data;
        }
      });
    },
    // 推荐表
    objectSpanMethodRecommendation({ row, column, rowIndex, columnIndex }) {
      if (this.subPackageFlag) {
        if (columnIndex < 2) {
          if ((rowIndex - row.devspan) % row.rowspan === 0) {
            return {
              rowspan: row.rowspan,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      }
    },
    //专家确认列表
    objectSpanMethodResult({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 1) {
        if ((rowIndex - row.devspan) % row.rowspan === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    deleteFile(index, type) {
      // 0:评标报告手签版 1：其他附件
      if (type == 0) {
        this.bidEvaluationReportTableData.splice(index, 1);
      } else {
        this.otherFileTableData.splice(index, 1);
      }
    },
    uploadSuccess(res, file, fileList) {
      let fileData = res.data[0];
      let obj = {
        fileUrl: fileData.downloadUrl,
        fileName: fileData.fileName,
        fileSize: Math.round(fileData.fileSize / 1024),
        fileDesc: "",
        fileSumm: "",
        createTime: fileData.createTime,
        uploadTime: fileData.createTime,
        fileinfoType: fileData.fileType,
        uploadId: fileData.uploadId,
        billType: "080701"
      };
      this.bidEvaluationReportTableData.push(obj);
      this.FileInfoBOs.push(obj);
    },
    // 上传类型错误
    handleErrorReport(res, file) {
      this.loading = false;
      console.log(res);
    },
    // 只能上传一个手牵版
    beforeUpload(file) {
      console.log(file);
      if (this.bidEvaluationReportTableData.length > 0) {
        this.$message({
          message: `因为${
            this.purchaseType == 1 ||
            this.purchaseType == 4 ||
            this.purchaseType == 7 ||
            this.purchaseType == 8
              ? "评审"
              : "评标"
          }报告手签附件只有一个，如果您要上传新手签附件请先删除所有手签列表附件！`,
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        this.loading = false;
        return false;
      }
      // 只能上传pdf、doc、docx
      let name = file.name;
      let type = name.substring(name.lastIndexOf(".") + 1);
      if (
        !(type.includes("doc") || type.includes("docx") || type.includes("pdf"))
      ) {
        this.$message({
          message: `${
            this.purchaseType == 1 ||
            this.purchaseType == 4 ||
            this.purchaseType == 7 ||
            this.purchaseType == 8
              ? "评审"
              : "评标"
          }报告手签只能上传word文档或pdf文档！`,
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        this.loading = false;
        return false;
      }
    },
    uploadChange(file, fileList) {
      this.loading = !this.loading;
    },
    uploadOtherFileSuccess(res, file, fileList) {
      let fileData = res.data[0];
      let obj = {
        fileUrl: fileData.downloadUrl,
        fileName: fileData.fileName,
        fileSize: Math.round(fileData.fileSize / 1024),
        fileDesc: "",
        fileSumm: "",
        createTime: fileData.createTime,
        uploadTime: fileData.createTime,
        fileinfoType: fileData.fileType,
        uploadId: fileData.uploadId,
        billType: "0807"
      };
      this.otherFileTableData.push(obj);
      this.FileInfoBOs.push(obj);
    },
    download(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid-scp/oss/downloadByUploadId?uploadId=${row.uploadId}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    // 保存
    dealBidReportSave(type) {
      if (this.form.textInfo === "") {
        this.$message({
          message: "评审总结不能为空！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return false;
      }
      let sscBidReportRecommendBOS = [];
      for (let i = 0; i < this.recommendationTableData.length; i++) {
        let item = this.recommendationTableData[i];
        if (item.recommendFlag === "") {
          this.$message({
            message: `包${item.packName}：${item.supName}的是否推荐不能为空！`,
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          return false;
        }
        let obj = {};
        obj.scoreSumId = item.scoreSumId;
        obj.packId = item.packId;
        obj.packName = item.packName;
        obj.supCode = item.supCode;
        obj.supName = item.supName;
        obj.Flag = item.recommendFlag;
        obj.reason = item.reason;
        obj.noTaxPriceAmount = item.noTaxPriceAmount;
        obj.priceAmount = item.priceAmount;
        obj.supJoinId = item.supJoinId;
        obj.supPackQuoteId = item.supPackQuoteId;
        obj.supQuoteId = item.supQuoteId;
        obj.taxAmount = item.taxAmount;
        sscBidReportRecommendBOS.push(obj);
      }
      let fileDatas = [];
      this.otherFileTableData.forEach(item => {
        fileDatas.push(item);
      });
      let param = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        bidReportId: this.bidReportId,
        projectName: this.form.projectName,
        projectCode: this.form.projectCode,
        agentIdNum: this.form.agentId,
        agentUserId: this.form.agentUserId,
        agentName: this.form.agentName,
        textInfo: this.form.textInfo,
        sscBidReportRecommendBOS: sscBidReportRecommendBOS,
        FileInfoBOs: fileDatas,
        fileinfoIds: [],
        requestLimit: true,
        isShowLoading: true
      };
      scpDealBidReportSaveApi(param).then(res => {
        if (res.data.code == "0") {
          this.$message({
            message: `${
              this.purchaseType == 1 ||
              this.purchaseType == 4 ||
              this.purchaseType == 7 ||
              this.purchaseType == 8
                ? "评审"
                : "评标"
            }报告保存成功！`,
            type: "success",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          this.editFlag = false;
          this.init(true);
        }
      });
    },
    // 提交确认
    dealBidReportSubmit() {
      let param = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        bidReportId: this.bidReportId,
        requestLimit: true,
        isShowLoading: true
      };
      scpDealBidReportSubmitApi(param).then(res => {
        if (res.data.code == "0") {
          this.init();
          this.$message({
            message: `${
              this.purchaseType == 1 ||
              this.purchaseType == 4 ||
              this.purchaseType == 7 ||
              this.purchaseType == 8
                ? "评审"
                : "评标"
            }报告提交确认成功！`,
            type: "success",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
        }
      });
    },
    // 预览评标报告
    prviewEvaluePrep() {
      this.bidEvaluationReportTableData.forEach(row => {
        let openUrl = document.createElement("a");
        openUrl.style.display = "none";
        openUrl.href = `${addUrlPerFix(
          process.env.VUE_APP_BASE_URL
        )}/apis/bid/oss/downloadByUploadId?fileUrl=${
          row.fileUrl
        }&fileName=${encodeURIComponent(row.fileName)}`;
        openUrl.setAttribute("download", row.fileName);
        document.body.appendChild(openUrl);
        openUrl.click();
      });
    },
    // 生效
    dealBidReportEffect() {
      // 手签版应该必须上传的，
      // 提交确认的时候，其他专家没确认的时候，应该有另外几个专家没进行确认的提示
      // if (this.bidEvaluationReportTableData.length > 0) {
      console.log(this.expertTableData, "this.expertTableData当前轮数据");
      let flag = true; // 是否所有专家都已经确认
      try {
        this.expertTableData.forEach(item => {
          // confirmStatus 0未确认,1已确认
          if (
            item.round ===
            this.expertTableData[this.expertTableData.length - 1].round
          ) {
            // 只校验最后一轮
            if (item.confirmStatus == 0) {
              flag = false;
              throw new Error();
            }
          }
        });
      } catch (e) {
        console.log(e);
      }
      if (!flag) {
        this.$confirm(
          `专家未全部确认或未全部同意，您确定要生效${
            this.purchaseType == 1 ||
            this.purchaseType == 4 ||
            this.purchaseType == 7 ||
            this.purchaseType == 8
              ? "评审"
              : "评标"
          }报告么？`,
          "生效确认",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            customClass: "ccui-message-box-custom"
          }
        )
          .then(res => {
            scpDealBidReportEffectApi({
              schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                .schemeId,
              evaPurStep: this.$router.history.current.query.evaPurStep,
              purStep: this.$router.history.current.query.menuKey,
              bidReportId: this.bidReportId,
              joinExpertId: JSON.parse(
                sessionStorage.getItem("expertSourceData")
              ).joinExpertId
            }).then(res => {
              if (res.data.code == "0") {
                // 评标报告已生效，评标室将自动关闭，评标状态为评标结束
                this.$message({
                  message: `${
                    this.purchaseType == 1 ||
                    this.purchaseType == 4 ||
                    this.purchaseType == 7 ||
                    this.purchaseType == 8
                      ? "评审"
                      : "评标"
                  }室已关闭！`,
                  type: "success",
                  duration: 3000,
                  showClose: true,
                  ccuiCustom: true
                });
                setTimeout(() => {
                  window.parent.postMessage(false, "*");
                }, 500);
              }
            });
          })
          .catch(() => {});
      } else {
        scpDealBidReportEffectApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          evaPurStep: this.$router.history.current.query.evaPurStep,
          purStep: this.$router.history.current.query.menuKey,
          bidReportId: this.bidReportId,
          joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .joinExpertId
        }).then(res => {
          if (res.data.code == "0") {
            // 评标报告已生效，评标室将自动关闭，评标状态为评标结束
            this.$message({
              message: `${
                this.purchaseType == 1 ||
                this.purchaseType == 4 ||
                this.purchaseType == 7 ||
                this.purchaseType == 8
                  ? "评审"
                  : "评标"
              }室已关闭！`,
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            setTimeout(() => {
              window.parent.postMessage(false, "*");
            }, 500);
          }
        });
      }
      // } else {
      //   this.$message({
      //     message: "评标报告手签版未上传！",
      //     type: "error",
      //     duration: 3000,
      //     showClose: true,
      //     ccuiCustom: true
      //   });
      // }
    },
    // 导出结束
    onContentChange(val, prop) {
      // this.baseInfoData[prop] = val;
    },
    selectedFile($event) {}
  }
};
</script>

<style lang="scss" scoped>
.fr {
  float: right;
}
.clear {
  clear: both;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
/deep/ .el-tabs__customize > .el-tabs__header {
  margin-bottom: 20px !important;
  padding-top: 20px !important;
}
.text_info {
  max-height: 420px;
  width: 100%;
  display: block;
  overflow-y: auto;
}
.pdfDom {
  width: 1123px;
  margin: 0 auto;
  padding: 20px 30px;
  .pdfDom-title {
    margin: 0 auto 20px;
    font-size: 22px;
    font-weight: bolder;
    text-align: center;
  }
  .pdfDom-table {
    width: 100%;
    height: auto;
    border: 1px solid;
    .pdfDom-table-row {
      width: 100%;
      border-bottom: 1px solid;
      display: flex;
      .pdfDom-table-col {
        padding: 0 4px;
        line-height: 36px;
        border-right: 1px solid;
        text-align: center;
        word-break: break-all;
      }
      .pdfDom-table-col:last-child {
        border-right: none;
        box-sizing: border-box;
        div {
          box-sizing: border-box;
        }
      }
    }
    .pdfDom-table-row:last-child {
      border-bottom: none;
    }
  }
}
</style>
